import React, { useState } from "react";
import { PageHeading } from "../../common/components";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  receivedError,
  requestSent,
  responseRecived,
} from "../../redux/actions/utilsActions";
import {
  editTimeSheet,
} from "../../api/soleTraderApi";
import { Button } from "react-bootstrap";

function EditTimeSheet() {
  const { userToken } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    daily_pay_rate: "",
    sole_trader_id: id
  });

  const EditTimeSheetApi = async () => {
    try {
      dispatch(requestSent());
      await editTimeSheet(userToken, formData);
      dispatch(responseRecived());
      navigate(-1)
      window.alert("Time sheet successfully edited!");
    } catch (error) {
      console.log(error, "error");
      dispatch(receivedError(error));
      dispatch(responseRecived());
      window.alert(error?.error_message, "Error");
    }
  };

  return (
    <div id="timesheet">
      <PageHeading title={"Timesheets"} />
      <div className="form-control container">
        <div className="mb-3">
          <label htmlFor="exampleInputPassword1" className="form-label">
            Daily Rate Of Pay
          </label>
          <input
            type="text"
            className="form-control"
            value={formData.daily_pay_rate}
            onChange={(text) => {
              setFormData({
                ...formData,
                daily_pay_rate: text.target.value,
              });
            }}
            id="exampleInputPassword1"
          />
        </div>

        <Button onClick={EditTimeSheetApi} className="btn btn-danger">
          Update
        </Button>
      </div>
    </div>
  );
}

export default EditTimeSheet;
